import { ContestDetailsModule } from '@/modules/fantasy/fixture/contest-details';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  id: z.coerce.string().optional(),
  fixtureId: z.coerce.string().optional(),
});

export const Route = createFileRoute(
  '/dashboard/fantasy/fixture/contest-details/'
)({
  validateSearch: searchSchema,
  component: ContestDetailsPage,
});

function ContestDetailsPage() {
  return <ContestDetailsModule />;
}
